import type {
  CandidateProfile,
  OverviewResponse,
  PositionRow,
  SearchDetail,
  SearchIndex,
  SearchListRow,
  Tier,
} from "@ow/shared";
import { api } from "./api";

const base = "/v1/client";

export const clientApi = {
  overview: () => api.get<OverviewResponse>(`${base}/overview`),
  searchIndex: () => api.get<SearchIndex>(`${base}/search-index`),
  searches: (tier?: Tier, fn?: string) => {
    const q = new URLSearchParams();
    if (tier) q.set("tier", tier);
    if (fn) q.set("function", fn);
    return api.get<SearchListRow[]>(`${base}/searches${q.toString() ? `?${q}` : ""}`);
  },
  searchDetail: (id: string) => api.get<SearchDetail>(`${base}/searches/${id}`),
  candidate: (id: string) => api.get<CandidateProfile>(`${base}/candidates/${id}`),
  positions: () => api.get<PositionRow[]>(`${base}/positions`),
};
